"use client";

import AntdRegistry from "@/components/AntdRegistry";
import { ConfigProvider } from "antd";
import React from "react";
import { AuthProvider } from "@/contexts/AuthContext";
import theme from "@/app/theme";

export function ClientProviders({ children }: { children: React.ReactNode }) {
  return (
    <AuthProvider>
      <AntdRegistry>
        <ConfigProvider theme={theme}>{children}</ConfigProvider>
      </AntdRegistry>
    </AuthProvider>
  );
}
